/* eslint-disable no-invalid-this */
const skuUtils = require('utils/Sku');
const dateUtils = require('utils/Date');
const safelyReadProperty = require('analytics/utils/safelyReadProperty');
const { SEPHORA_CARD_TYPES } = require('constants/CreditCard');
// const store = require('Store');
// Do not require ^^^ 'Store' module here like this because
// it can be not initialized at the time when current module is required
//
// Example:
//  app.js =>
//      require('ReduxProvider.jsx') =>
//          require('Store.js') =>
//              require('reducers.js') =>
//                  require('reducers/order.js') =>
//                      require('utils/Order.js') =>
//                          require('Store.js') - here is a circular dependency!!! :-(
//
// Because of that 'store' const at line #6 will be initialized with empty object and
// invocation of store.getState() from any util function will lead to exception.
// We should never ever use/work with Redux state via direct reference to "require('Store')" in new files/code
// From 07.21.2021 project uses 'react-redux' library so please use 'connect' function to read data from store.
// From now ^^^ this is the only correct way of getting data from Redux store for new implementations.
// If you think you need "require('Store')" in your new file then probably you are doing something wrong!

// Workaround for getting access to Redux store for old code if you have circular dependency issue.
const getStoreState = () => require('Store').getState();

const Actions = require('Actions');
const { getProp } = require('utils/Helpers');
const BASKET_TYPES = {
    PREBASKET: 'prebasket',
    DC_BASKET: 'distribution center basket',
    ROPIS_BASKET: 'reserve and pick up basket',
    BOPIS_BASKET: 'buy online and pick up basket',
    SAMEDAY_BASKET: 'SameDay',
    STANDARD_BASKET: 'ShipToHome'
};

const ROPIS_CONSTANTS = {
    ORDER_STATUS: {
        COMPLETED: 'completed',
        ACTIVE: 'active',
        PENDING: 'pending'
    },
    HEADER_LEVEL_ORDER_STATUS: {
        PICKED_UP: 'Picked Up',
        READY_FOR_PICK_UP: 'Ready for Pickup',
        PROCESSING: 'Processing',
        CANCELED: 'Canceled'
    }
};
const PAYMENT_GROUP_TYPE = {
    CREDIT_CARD: 'CreditCardPaymentGroup',
    DEBIT_CARD: 'DebitCardPaymentGroup',
    STORE_CREDIT: 'StoreCreditPaymentGroup',
    GIFT_CARD: 'GiftCardPaymentGroup',
    EGIFT_CARD: 'ElectronicGiftCardPaymentGroup',
    PAYPAL: 'PayPalPaymentGroup',
    APPLEPAY: 'ApplePayPaymentGroup',
    KLARNA: 'KlarnaPaymentGroup'
};

const SHIPPING_GROUPS = {
    HARD_GOOD: 'HardGoodShippingGroup',
    GIFT: 'GiftCardShippingGroup',
    FLASH: 'FlashElectronicShippingGroup',
    ELECTRONIC: 'ElectronicShippingGroup',
    SAME_DAY: 'SameDayShippingGroup'
};

const SHIPPING_METHOD_TYPES = {
    FLASH: 'Sephora FLASH',
    PLAY: 'Play! by Sephora'
};

const SHIPPING_METHOD_ID = {
    FLASH_SHIP_METHOD_ID: '9300001',
    FLASH_SHIP_GROUND_ID: '9300002',
    PLAY_SHIP_METHOD_ID: ['9000030', '9000031', '9000032', '9000033', '9000034']
};

const PAYMENT_TYPE = {
    CREDIT_CARD: {
        'sephora': 'sephora',
        'visa': 'visa',
        'masterCard': 'master-card',
        'americanExpress': 'american-express',
        'discover': 'discover',
        'JCPenney': 'JCPenney'
    },
    DEBIT_CARD: {
        'debit': 'debit',
        'visa': 'visa',
        'masterCard': 'master-card',
        'americanExpress': 'american-express',
        'discover': 'discover',
        'JCPenney': 'JCPenney'
    },
    OTHER: {
        'storeCredit': PAYMENT_GROUP_TYPE.STORE_CREDIT,
        'payPal': PAYMENT_GROUP_TYPE.PAYPAL,
        'applePay': PAYMENT_GROUP_TYPE.APPLEPAY,
        'klarna': PAYMENT_GROUP_TYPE.KLARNA,
        'giftCard': PAYMENT_GROUP_TYPE.GIFT_CARD,
        'egiftCard': PAYMENT_GROUP_TYPE.EGIFT_CARD
    }
};

const CREDIT_CARD_TYPES = {
    SEPHORA: {
        name: 'sephora',
        displayName: 'Sephora Card'
    },
    VISA: {
        name: 'visa',
        displayName: 'VISA'
    },
    MASTERCARD: {
        name: 'masterCard',
        displayName: 'MasterCard'
    },
    DISCOVER: {
        name: 'discover',
        displayName: 'Discover'
    },
    AMERICAN_EXPRESS: {
        name: 'americanExpress',
        displayName: 'American Express'
    },
    JCPENNEY: {
        name: 'JCPenney',
        displayName: 'JCPenney'
    }
};

const ALL_CARD_TYPES = Object.assign({
    [SEPHORA_CARD_TYPES.PRIVATE_LABEL]: {
        name: 'sephora',
        displayName: SEPHORA_CARD_TYPES.PRIVATE_LABEL
    },
    [SEPHORA_CARD_TYPES.PRIVATE_LABEL_TEMP]: {
        name: 'sephora',
        displayName: SEPHORA_CARD_TYPES.PRIVATE_LABEL_TEMP
    },
    [SEPHORA_CARD_TYPES.CO_BRANDED]: {
        name: 'sephora',
        displayName: SEPHORA_CARD_TYPES.CO_BRANDED
    },
    [SEPHORA_CARD_TYPES.CO_BRANDED_TEMP]: {
        name: 'sephora',
        displayName: SEPHORA_CARD_TYPES.CO_BRANDED_TEMP
    }
}, CREDIT_CARD_TYPES);

const PAYMENT_GROUPS = { CREDIT_CARD: 'CreditCardPaymentGroup' };

const ORDER_TRACKING_BUTTON_STATES = {
    PENDING: 'Pending',
    CANCELED: 'Cancelled',
    ACTIVE: 'Active',
    DELIVERED: 'Delivered'
};

const ZERO_CHECKOUT_OPTIONS = {
    US: '$0.00',
    CA_EN: '$0.00',
    CA_FR: '0,00 $'
};

const CARD_TYPES = {
    CreditCard: 'CreditCardPaymentGroup',
    PayPal: 'PayPalPaymentGroup',
    Klarna: 'KlarnaPaymentGroup'
};

const FIRST_INCENTIVE_DISCOUNT = 'firstbuypercentoff';

const paymentGroupOptions = (paymentType) => {
    return {
        [CARD_TYPES.PayPal]: {
            img: {
                alt: 'Pay Pal',
                logo: 'payPal'
            },
            text: 'paypalAccount'
        },
        [CARD_TYPES.Klarna]: {
            img: {
                alt: paymentType === 'Paybright' ? 'PayBright' : 'Klarna',
                logo: paymentType === 'Paybright' ? 'paybright' : 'klarna'
            },
            text: 'paidWith'
        }
    };
};

function isAlternativePaymentMethod(paymentGroupType, paymentGroup) {
    return (paymentGroupType === CARD_TYPES.PayPal) ||
        (paymentGroup.isApplePay && paymentGroup.paymentDisplayInfo) ||
        (paymentGroupType === CARD_TYPES.Klarna);
}

function alternativePaymentAltSrc(paymentGroupType, paymentGroup) {
    const alt = paymentGroup.isApplePay ? 'Apple Pay' : paymentGroupOptions(paymentGroup.paymentDisplayInfo)[paymentGroupType].img.alt;
    const src = `/img/ufe/payments/${paymentGroup.isApplePay ? 'applePay' : paymentGroupOptions(paymentGroup.paymentDisplayInfo)[paymentGroupType].img.logo}.svg`;
    return {
        alt,
        src
    };
}

function alternativePaymentText(paymentGroupType, paymentGroup) {
    return paymentGroup.isApplePay ? 'applePay' : paymentGroupOptions()[paymentGroupType].text;
}

function alternativePaymentInfo(paymentGroupType, paymentGroup) {
    if (paymentGroup.isApplePay) {
        return paymentGroup.paymentDisplayInfo;
    } else if (paymentGroupType === CARD_TYPES.PayPal) {
        return paymentGroup.email;
    } else if (paymentGroupType === CARD_TYPES.Klarna) {
        return paymentGroup.paymentDisplayInfo === 'Paybright' ? 'PayBright' : 'Klarna';
    } else {
        return '';
    }
}

function isDisabled(status) {
    return status === ORDER_TRACKING_BUTTON_STATES.PENDING ||
        status === ORDER_TRACKING_BUTTON_STATES.CANCELED;
}

function isActive(status) {
    return status === ORDER_TRACKING_BUTTON_STATES.ACTIVE;
}

function isCanceled(status) {
    return status === ORDER_TRACKING_BUTTON_STATES.CANCELED;
}

function isDelivered(status) {
    return status === ORDER_TRACKING_BUTTON_STATES.DELIVERED;
}

function getShipmentDate(orderData) {
    return orderData.shippingGroups[0].shipmentDate;
}

function getOrderTotal() {
    let priceInfo = getStoreState().order.orderDetails.priceInfo;
    return priceInfo.orderTotal;
}

function getCreditCardTotal(orderDetails) {
    if (!orderDetails) {
        orderDetails = getStoreState().order.orderDetails;
    }
    return orderDetails.priceInfo.creditCardAmount;
}

function getPayPalAmount(orderDetails) {
    if (!orderDetails) {
        orderDetails = getStoreState().order.orderDetails;
    }
    return orderDetails.priceInfo.paypalAmount;
}

function getOrderId() {
    let { header = {} } = getStoreState().order.orderDetails;
    return header.orderId;
}

function getSelfCancelationReasons() {
    let { header = {} } = getStoreState().order.orderDetails;
    return header.selfCancellationReasonCodes;
}

function getOrderDetailsUrl(orderId) {
    return `/profile/orderdetail/${orderId}`;
}

function getAllPurchasesUrl() {
    return '/account/orders/';
}

function getOrderHistoryUrl() {
    return '/profile/MyAccount/Orders';
}

// used in my account for play and flash
function getPaymentDisplayInfo(paymentData) {
    if (paymentData.paymentGroupsEntries &&
        paymentData.paymentGroupsEntries.length) {

        if (paymentData.paymentGroupsEntries[0].paymentGroupType === 'PayPalPaymentGroup') {
            return 'PayPal Account ' + paymentData.paymentGroupsEntries[0].paymentGroup.email;
        } else {
            return paymentData.paymentGroupsEntries[0].paymentGroup.paymentDisplayInfo;
        }
    }
    return false;
}

function getCreditCardPaymentGroup(orderDetails) {
    let paymentGroupsEntries = orderDetails.paymentGroups && orderDetails.paymentGroups.paymentGroupsEntries;
    if (paymentGroupsEntries) {
        for (let i = 0; i < paymentGroupsEntries.length; i++) {
            if (paymentGroupsEntries[i].paymentGroupType === PAYMENT_GROUPS.CREDIT_CARD) {
                return paymentGroupsEntries[i].paymentGroup;
            }
        }
    }
    return null;
}

function getPayPalPaymentGroup(orderDetails) {
    let paymentGroupsEntries = orderDetails.paymentGroups && orderDetails.paymentGroups.paymentGroupsEntries;
    if (paymentGroupsEntries) {
        for (let i = 0; i < paymentGroupsEntries.length; i++) {
            if (paymentGroupsEntries[i].paymentGroupType === PAYMENT_GROUP_TYPE.PAYPAL) {
                return paymentGroupsEntries[i].paymentGroup;
            }
        }
    }
    return null;
}

function getKlarnaPaymentGroup(orderDetails) {
    let paymentGroupsEntries = orderDetails.paymentGroups && orderDetails.paymentGroups.paymentGroupsEntries;
    if (paymentGroupsEntries) {
        for (let i = 0; i < paymentGroupsEntries.length; i++) {
            if (paymentGroupsEntries[i].paymentGroupType === PAYMENT_GROUP_TYPE.KLARNA) {
                return paymentGroupsEntries[i].paymentGroup;
            }
        }
    }
    return null;
}

function getGiftCardPaymentGroups(orderDetails) {
    let giftCardPaymentGroups = [];
    let paymentGroupsEntries = orderDetails.paymentGroups && orderDetails.paymentGroups.paymentGroupsEntries;
    if (paymentGroupsEntries) {
        for (let i = 0; i < paymentGroupsEntries.length; i++) {
            if (paymentGroupsEntries[i].paymentGroupType === PAYMENT_GROUP_TYPE.GIFT_CARD) {
                giftCardPaymentGroups.push(paymentGroupsEntries[i].paymentGroup);
            }
        }
    }
    return giftCardPaymentGroups;
}

function getStoreCredits(orderDetails) {
    return orderDetails.paymentGroups && orderDetails.paymentGroups.storeCredits || [];
}

function getTrackingUrl(orderDetails) {
    const trackingUrl = orderDetails.shippingGroups.filter(group => !!group.trackingUrl);
    return trackingUrl.length > 0 ? trackingUrl[0].trackingUrl : null;
}

function getCreditCardAddress(orderDetails) {
    let creditCardGroup = getCreditCardPaymentGroup(orderDetails);
    if (creditCardGroup) {
        return creditCardGroup.address;
    }
    return false;
}

function allowUpdatedShippingCalculationsMsg(orderDetails) {
    let shipGroups = orderDetails.shippingGroups;
    return shipGroups.isPromiseDateInfoNoteEnabled;
}

function getShippingGroup(orderDetails, shippingType) {
    let shipGroupsEntries = orderDetails?.shippingGroups?.shippingGroupsEntries;
    if (shipGroupsEntries) {
        for (let i = 0; i < shipGroupsEntries.length; i++) {
            if (shipGroupsEntries[i].shippingGroupType === shippingType) {
                return shipGroupsEntries[i].shippingGroup;
            }
        }
    }
    return null;
}

function getHardGoodShippingGroup(orderDetails) {
    return getShippingGroup(orderDetails, SHIPPING_GROUPS.HARD_GOOD);
}

function getSameDayShippingGroup(orderDetails) {
    return getShippingGroup(orderDetails, SHIPPING_GROUPS.SAME_DAY);
}

function getHardGoodShippingAddress(orderDetails) {
    let hardGoodShipGroup = getHardGoodShippingGroup(orderDetails);
    if (hardGoodShipGroup) {
        return hardGoodShipGroup.address;
    }
    return null;
}

function getBasket(basketType, orderDetails) {
    return (orderDetails.items.itemsByBasket || []).find(item => item.basketType === basketType) || {};
}

function getSameDayDeliveryBasket(orderDetails) {
    return getBasket(BASKET_TYPES.SAMEDAY_BASKET, orderDetails);
}

function getStandardBasket(orderDetails) {
    return getBasket(BASKET_TYPES.STANDARD_BASKET, orderDetails);
}

function hasSameDayDeliveryItems(orderDetails) {
    const sddBasket = getSameDayDeliveryBasket(orderDetails);
    return (sddBasket.items || []).length > 0;
}

function hasStandardDeliveryItems(orderDetails) {
    const basket = getStandardBasket(orderDetails);
    return (basket.items || []).length > 0;
}

function getSameDayShippingAddress(orderDetails) {
    let sameDayShipGroup = getSameDayShippingGroup(orderDetails);
    if (sameDayShipGroup) {
        return sameDayShipGroup.address;
    }
    return null;
}

function getNonPromoItemsCount(orderDetails) {
    let itemsCount = orderDetails.items.itemCount;
    orderDetails.items.items.forEach(item => {
        if (skuUtils.isGwp(item.sku)) {
            itemsCount--;
        }
    });
    return itemsCount;
}

function getBasketLevelRewardMessage() {
    let { items = {} } = getStoreState().order.orderDetails;
    const basketLevelRWmessage = items.basketLevelMessages && items.basketLevelMessages.filter(
        (msg) => msg.messageContext === 'basket.RWPromoUsageMsg'
    );
    return basketLevelRWmessage && basketLevelRWmessage.length ?
        basketLevelRWmessage[0].messages.join(',') : '';
}

function isZeroPrice(price) {
    const zeroOptions = Object.values(ZERO_CHECKOUT_OPTIONS);
    return !price || zeroOptions.some(opt => price.indexOf(opt) === 0);
}

function isZeroCheckout() {
    return isZeroPrice(getOrderTotal());
}

// all of the helper functions below are from
// mobile-web/public/js/app/resources/checkout/Order.js

function isPlayOrder() {
    let { header = {} } = getStoreState().order.orderDetails;
    return header.isPlaySubscriptionOrder;
}

function isPlayEditOrder() {
    let { header = {} } = getStoreState().order.orderDetails;
    return header.isPlaySubscriptionUpdateOrder;
}

function isPlayTCChecked() {
    const FormsUtils = require('utils/Forms');
    let editData = getStoreState().editData || {};
    return editData[FormsUtils.FORMS.CHECKOUT.PLAY_TC_CHECKBOX];
}

function getPhysicalGiftCardShippingGroup(orderDetails) {
    let shipGroupEntries = orderDetails.shippingGroups?.shippingGroupsEntries;
    if (shipGroupEntries) {
        for (let i = 0; i < shipGroupEntries.length; i++) {
            if (shipGroupEntries[i].shippingGroupType === SHIPPING_GROUPS.GIFT) {
                return shipGroupEntries[i].shippingGroup;
            }
        }
    }
    return null;
}

function getPromisedDelivery(shippingGroup) {
    let promiseDate = getProp(shippingGroup, 'shippingMethod.promiseDate', false);

    if (promiseDate) {
        return dateUtils.getPromiseDate(promiseDate, true);
    }
    return null;
}


function getEstimatedDelivery(shippingGroup) {
    let shipMethod = shippingGroup.shippingMethod;

    if (shipMethod && shipMethod.shippingMethodId &&
        SHIPPING_METHOD_ID.PLAY_SHIP_METHOD_ID.some((id) => shipMethod.shippingMethodId === id)) {
        return `${shipMethod.shippingMethodType} ${shipMethod.shippingMethodDescription}`;
    } else if (shipMethod) {
        const {
            estimatedMinDeliveryDate,
            estimatedMaxDeliveryDate
        } = shipMethod;

        const estimatedMinDate = dateUtils.getEstimatedDeliveryString(estimatedMinDeliveryDate);
        const estimatedMaxDate = dateUtils.getEstimatedDeliveryString(estimatedMaxDeliveryDate);

        return estimatedMinDeliveryDate === estimatedMaxDeliveryDate ?
            estimatedMinDate : `${estimatedMinDate} to ${estimatedMaxDate}`;
    } else {
        return null;
    }
}

function isFlashOrElectronicShippingGroup(shippingGroup) {
    let shipGroupType = shippingGroup.shippingGroupType;
    if (shipGroupType === SHIPPING_GROUPS.ELECTRONIC || shipGroupType === SHIPPING_GROUPS.FLASH) {
        return true;
    }
    return false;
}

function isFlashOrder(orderDetails) {
    let shipGroupsEntries = orderDetails.shippingGroups?.shippingGroupsEntries;
    if (shipGroupsEntries) {
        for (let i = 0; i < shipGroupsEntries.length; i++) {
            let group = shipGroupsEntries[i];
            if (group.shippingGroupType && group.shippingGroupType === SHIPPING_GROUPS.FLASH) {
                return true;
            }
        }
    }
    return false;
}

function isShippableOrder(orderDetails) {
    const {
        HARD_GOOD, GIFT
    } = SHIPPING_GROUPS;
    const shipGroupsEntries = orderDetails.shippingGroups?.shippingGroupsEntries;
    if (shipGroupsEntries) {
        return shipGroupsEntries.some(group => {
            return [HARD_GOOD, GIFT].indexOf(group.shippingGroupType) > -1;
        });
    } else {
        return false;
    }
}

function isFlashOnlyOrder(orderDetails) {
    let shipGroupsEntries = orderDetails.shippingGroups?.shippingGroupsEntries;
    let isFlashOnly = typeof shipGroupsEntries === 'undefined' ? false : true;
    if (shipGroupsEntries) {
        for (let i = 0; i < shipGroupsEntries.length; i++) {
            let group = shipGroupsEntries[i];
            if (group.shippingGroupType && group.shippingGroupType !== SHIPPING_GROUPS.FLASH) {
                isFlashOnly = false;
                break;
            }
        }
    }
    return isFlashOnly;
}

function isFlashOrGiftCardOnly() {
    let orderDetails = getStoreState().order.orderDetails;
    let shipGroupsEntries = orderDetails.shippingGroups?.shippingGroupsEntries;
    let isFlashGCOnly = typeof shipGroupsEntries === 'undefined' ? false : true;
    if (shipGroupsEntries) {
        for (let i = 0; i < shipGroupsEntries.length; i++) {
            let group = shipGroupsEntries[i];
            if (group.shippingGroupType &&
                group.shippingGroupType !== SHIPPING_GROUPS.FLASH &&
                group.shippingGroupType !== SHIPPING_GROUPS.GIFT
            ) {
                isFlashGCOnly = false;
                break;
            }
        }
    }
    return isFlashGCOnly;
}

function isFlashTCChecked() {
    const FormsUtils = require('utils/Forms');
    let editData = getStoreState().editData || {};
    return editData[FormsUtils.FORMS.CHECKOUT.FLASH_TC_CHECKBOX];
}

function isHazardous(orderItems = []) {
    return !!orderItems.filter((item) => item.sku.isHazmat).length;
}

function isRestrictedInCalifornia(orderItems = []) {
    return !!orderItems.filter((item) => item.sku.isProp65).length;
}

function userHasSavedPayPalAccount(orderDetails) {
    //Need to check that profile exists in case of guest checkout
    return orderDetails.header.profile &&
        orderDetails.header.profile.hasSavedPaypal;
}

function getGuestEmail(orderDetails) {
    return orderDetails.header.guestProfile && orderDetails.header.guestProfile.email;
}

function containsRestrictedItem() {
    let orderItems = getStoreState().order.orderDetails.items.items;
    return !!orderItems.filter((item) => item.sku.isPaypalRestricted).length;
}

function getAvailableBiPoints() {
    let basket = getStoreState().order.orderDetails.items;
    return basket.netBeautyBankPointsAvailable ? basket.netBeautyBankPointsAvailable : 0;
}

function getGuestAvailableBiPoints() {
    let basket = getStoreState().order.orderDetails.items;
    return basket.potentialBeautyBankPoints ? basket.potentialBeautyBankPoints : 0;
}

function isPayPalSaveToAccountChecked() {
    const FormsUtils = require('utils/Forms');
    let orderDetails = getStoreState().order.orderDetails;
    //need to return true if user has saved paypal account so that
    //if user updates to a new paypal account it saves to profile
    //otherwise we need to check if 'save to account' box has been checked
    if (userHasSavedPayPalAccount(orderDetails)) {
        return true;
    } else {
        let editData = getStoreState().editData || {};
        return editData[FormsUtils.FORMS.CHECKOUT.PAYPAL_SAVE_CHECKBOX];
    }
}

function getGlobalPromoCount(items) {
    let promoCount = 0;

    for (let i = 0; i < items.length; i++) {
        if (items[i].isGlobalPromotion) {
            promoCount++;
        }
    }

    return promoCount;
}

function getThirdPartyCreditCard(creditCard) {
    const cardType = creditCard.cardType.toLowerCase();

    const cardDetected = Object.keys(ALL_CARD_TYPES).find(card => ALL_CARD_TYPES[card].
        displayName.toLowerCase() === cardType);

    return cardDetected ? ALL_CARD_TYPES[cardDetected].name : '';
}

function isShipmentRestriction(orderDetails) {
    let shippingRestrictionMessages;
    let hardGoodShippingGroup = getHardGoodShippingGroup(orderDetails);
    if (hardGoodShippingGroup && hardGoodShippingGroup.shipmentWarningMessages) {
        shippingRestrictionMessages = hardGoodShippingGroup.shipmentWarningMessages
            .filter((message) => {
                return message.messageContext === 'shippingRestriction';
            });
    }
    return shippingRestrictionMessages && !!shippingRestrictionMessages.length;
}

function isPayPalEnabled(orderDetails) {
    return orderDetails.header && orderDetails.header.isPaypalPaymentEnabled;
}

function hasAmountDue(orderDetails) {
    return !!getCreditCardTotal(orderDetails) || !!getPayPalAmount(orderDetails);
}

function hasFirstPurchaseDiscountApplied(orderDetails) {
    const appliedPromotions = getProp(orderDetails, 'promotion.appliedPromotions', []);
    return appliedPromotions.some(reward => reward.couponCode === FIRST_INCENTIVE_DISCOUNT);
}

function isKlarnaEnabled(orderDetails) {
    if (!orderDetails) {
        orderDetails = getStoreState().order.orderDetails;
    }
    return orderDetails.items &&
        orderDetails.items.isKlarnaCheckoutEnabled &&
        hasAmountDue(orderDetails) && !hasFirstPurchaseDiscountApplied(orderDetails);
}

function hasPromoCodes(orderDetails) {
    const details = orderDetails ? orderDetails : getStoreState().order.orderDetails;
    const appliedPromotions = details.promotion && details.promotion.appliedPromotions ?
        details.promotion.appliedPromotions : [];

    return appliedPromotions.length > 0;
}

function shouldShowPromotion() {
    const isPlayCheckout = this.isPlayOrder() || this.isPlayEditOrder();
    return !isPlayCheckout &&
        (!this.isZeroCheckout() || this.hasPromoCodes()) &&
        !this.isFlashOrGiftCardOnly();
}

const detectSephoraCard = card => {
    const {
        sephCBVIBinRange, sephPLCCBinRange
    } =
        Sephora.fantasticPlasticConfigurations;

    const ranges = {
        [sephCBVIBinRange]: SEPHORA_CARD_TYPES.CO_BRANDED,
        [sephPLCCBinRange]: SEPHORA_CARD_TYPES.PRIVATE_LABEL
    };

    const binRange = String(card).substring(0, 6);
    return ranges[binRange];
};

const whichSephoraCard = type => card => detectSephoraCard(card) === type;
const isCoBranded = whichSephoraCard(SEPHORA_CARD_TYPES.CO_BRANDED);
const isPrivateLabel = whichSephoraCard(SEPHORA_CARD_TYPES.PRIVATE_LABEL);

const isSephoraCardNumber = card => detectSephoraCard(card) !== undefined;

function isSephoraCardType(creditCard) {
    const sephoraCardTypes = Object.values(SEPHORA_CARD_TYPES);
    return creditCard && sephoraCardTypes.indexOf(creditCard.cardType) !== -1;
}

function isSephoraTempCardType(creditCard) {
    const sephoraTempCardTypes =
        [SEPHORA_CARD_TYPES.PRIVATE_LABEL_TEMP, SEPHORA_CARD_TYPES.CO_BRANDED_TEMP];
    return creditCard && sephoraTempCardTypes.indexOf(creditCard.cardType) !== -1;
}

function getTempSephoraCardMessage() {
    let orderDetails = getStoreState().order.orderDetails;
    let headerPaymentGroups = orderDetails.header.paymentGroups || [];
    for (let i = 0; i < headerPaymentGroups.length; i++) {
        let group = headerPaymentGroups[i];
        if (group.tempSephCardUsageMsg && group.tempSephCardUsageMsg.length) {
            return group.tempSephCardUsageMsg[0];
        }
    }
    return null;
}

function getMerchandiseSubtotalAsNumber() {
    let merchSubTotal = getStoreState().order.orderDetails.priceInfo.merchandiseSubtotal || '0.00';
    return isZeroCheckout() ? 0 : Number(merchSubTotal.replace(/[^0-9.,-]+/g, '').replace(/,/g, '.'));
}

function hasRRC(orderDetails) {
    return orderDetails.promotion.appliedPromotions.some(
        promo => promo.displayName === 'Rouge Reward'
    );
}

function getZipCode(shipGroups) {
    let zipCode = '';
    for (let group of shipGroups) {
        if (safelyReadProperty('shippingGroup.address.postalCode', group) !== '') {
            zipCode += safelyReadProperty('shippingGroup.address.postalCode', group);
            break;
        }
    }
    return zipCode;
}

function showOrderCancelationModal(orderId) {
    const { dispatch } = require('Store');
    dispatch(Actions.showOrderCancelationModal(true, orderId, getSelfCancelationReasons()));
}

module.exports = {
    ROPIS_CONSTANTS,
    isDisabled,
    isActive,
    isCanceled,
    isDelivered,
    getShipmentDate,
    getOrderId,
    getOrderTotal,
    getOrderDetailsUrl,
    getOrderHistoryUrl,
    getAllPurchasesUrl,
    getPaymentDisplayInfo,
    getCreditCardAddress,
    getHardGoodShippingAddress,
    getHardGoodShippingGroup,
    getSameDayShippingGroup,
    getSameDayShippingAddress,
    getPhysicalGiftCardShippingGroup,
    getCreditCardPaymentGroup,
    getPayPalPaymentGroup,
    getKlarnaPaymentGroup,
    getGiftCardPaymentGroups,
    getStoreCredits,
    getTrackingUrl,
    getBasketLevelRewardMessage,
    isZeroCheckout,
    isFlashOrElectronicShippingGroup,
    isFlashOrder,
    isShippableOrder,
    isFlashOnlyOrder,
    isFlashTCChecked,
    isPlayOrder,
    isPlayTCChecked,
    isPlayEditOrder,
    isHazardous,
    isRestrictedInCalifornia,
    isPayPalEnabled,
    isKlarnaEnabled,
    hasAmountDue,
    getNonPromoItemsCount,
    getPromisedDelivery,
    getEstimatedDelivery,
    userHasSavedPayPalAccount,
    containsRestrictedItem,
    isFlashOrGiftCardOnly,
    shouldShowPromotion,
    getAvailableBiPoints,
    getGuestAvailableBiPoints,
    isPayPalSaveToAccountChecked,
    getGlobalPromoCount,
    getSelfCancelationReasons,
    getGuestEmail,
    getThirdPartyCreditCard,
    isShipmentRestriction,
    getCreditCardTotal,
    getPayPalAmount,
    hasPromoCodes,
    isCoBranded,
    isPrivateLabel,
    detectSephoraCard,
    isSephoraCardNumber,
    isSephoraCardType,
    isSephoraTempCardType,
    getTempSephoraCardMessage,
    isAlternativePaymentMethod,
    alternativePaymentAltSrc,
    alternativePaymentText,
    alternativePaymentInfo,
    PAYMENT_TYPE,
    CREDIT_CARD_TYPES,
    CARD_TYPES,
    PAYMENT_GROUP_TYPE,
    SHIPPING_GROUPS,
    SHIPPING_METHOD_TYPES,
    SHIPPING_METHOD_ID,
    PAYMENT_GROUPS,
    ZERO_CHECKOUT_OPTIONS,
    ORDER_TRACKING_BUTTON_STATES,
    getMerchandiseSubtotalAsNumber,
    allowUpdatedShippingCalculationsMsg,
    hasRRC,
    isZeroPrice,
    getZipCode,
    showOrderCancelationModal,
    getBasket,
    getSameDayDeliveryBasket,
    getStandardBasket,
    hasSameDayDeliveryItems,
    hasStandardDeliveryItems
};
